import { useEffect, useState } from "react";
import LoadingSkeleton from "./LoadingSkeleton";
import { AntdTable, TableContainer } from "./styles";

export default function DataTable({
	data,
	fetch,
	columns,
	loading = false,
	state,
	containerMarginTop = null,
	containerBackground = null,
	background = null,
	rowBackground = null,
	showHeader = true,
	...props
}) {
	const [pagination, setPagination] = useState({
		current: 1,
		showSizeChanger: false,
	});

	const fetchData = async (params = {}) => {
		await fetch(params.pagination.current, state && state);

		setPagination({
			...params.pagination,
		});
	};

	useEffect(() => {
		if (!data) return;
		setPagination({
			...pagination,
			total: data.totalCount,
			pageSize: data.pageSize,
			current: data.pageNumber,
			showTotal: (total) => `Total ${total} items`,
		});
	}, [data]);

	const handleTableChange = (newPagination, filters, sorter) => {
		fetchData({
			sortField: sorter.field,
			sortOrder: sorter.order,
			pagination: newPagination,
			...filters,
		});
	};

	if (!data) return <LoadingSkeleton />;

	return (
		<TableContainer
			containerBackground={containerBackground}
			containerMarginTop={containerMarginTop}
		>
			<AntdTable
				loading={loading}
				columns={columns}
				rowKey={(record) => record.id}
				dataSource={data.items}
				pagination={pagination}
				onChange={handleTableChange}
				background={background}
				rowBackground={rowBackground}
				showHeader={showHeader}
				{...props}
			/>
		</TableContainer>
	);
}
